import type { IExtractRouteParamMap, IRouteTranslation } from "../../types";
import { createBreadcrumbObject, createPaths } from "../../utils";

// Base route constant
const baseRoute = `/crawler-management`;

// * Route configuration object for crawlerManagement-related paths.
// ! This object is `readonly` to ensure route parameters are extracted properly.
export const crawlerManagementRoutesObj = {
  home: baseRoute,
} as const;

// ! these are breadcrumbs translation not page title
const crawlerManagementRouteTranslation: IRouteTranslation<
  typeof crawlerManagementRoutesObj
> = {
  home: "crawlerManagement",
};

// * Extracts the route parameters for the crawlerManagement route configuration.
export type ICrawlerManagementRouteParams = IExtractRouteParamMap<
  typeof crawlerManagementRoutesObj
>;

// * Path functions for the crawlerManagement routes.
export const crawlerManagementPath = createPaths<
  typeof crawlerManagementRoutesObj,
  ICrawlerManagementRouteParams
>(crawlerManagementRoutesObj);

// * Breadcrumbs {translation and route} for the faculty routes
export const crawlerManagementBreadcrumbs = createBreadcrumbObject<
  typeof crawlerManagementRoutesObj
>(crawlerManagementRoutesObj, crawlerManagementRouteTranslation);
